import { render, staticRenderFns } from "./IsBankasiForm.vue?vue&type=template&id=35b379fc"
import script from "./IsBankasiForm.vue?vue&type=script&lang=js"
export * from "./IsBankasiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports